import { TransparencyOverlay } from "@faire/web/ui/TransparencyOverlay";
import React from "react";

import * as styles from "./__internal__/overlay.css";

interface OverlayProps {
  overlayStyle: OverlayStyle;
}

export enum OverlayStyle {
  BACKORDERED,
  DARKENING,
  NONE,
}

export const Overlay: React.FC<OverlayProps> = ({ overlayStyle }) => {
  switch (overlayStyle) {
    case OverlayStyle.BACKORDERED:
      return <div className={styles.redesignedBackorderedOverlay} />;
    case OverlayStyle.DARKENING:
      return <TransparencyOverlay />;
    default:
      return null;
  }
};
